import { menuParameterDisp, sentBuryPointInfo } from './buryPoint'

// 专门记录下载埋点
export const downloadTracking = (product, url, eventContext) => {
  const parameter = menuParameterDisp(product, url)
  if (parameter) {
    sentBuryPointInfo({
      ...parameter,
      eventName: '点击下载',
      eventCode: 'download',
      eventContext: {
        ...eventContext,
        data: filterParams(eventContext.data),
        params: filterParams(eventContext.params)
      }
    })
  }
}
const filterParams = (params, keys = ['token']) => {
  if (!params) return params
  try {
    const data = JSON.parse(params)
    const res = {}
    Object.keys(data)
      .filter(val => !keys.includes(val))
      .map(k => {
        res[k] = data[k]
      })
    return JSON.stringify(res)
  } catch (e) {
    return params
  }
}

/**
 * 树形数组转一维数组
 * @param Array _array_tree
 * @param Number id
 * @param Number pid
 * @param Array son
 */
export function arr2table(_array_tree, son = 'children') {
  let tree = []
  for (const i in _array_tree) {
    const _tree = {}
    let sub = []
    for (const key in _array_tree[i]) {
      if (key === son) {
        sub = _array_tree[i][son]
      } else {
        _tree[key] = _array_tree[i][key]
      }
    }
    tree.push(_tree)
    if (sub) {
      const sub_array = arr2table(sub, son)
      tree = tree.concat(sub_array)
    }
  }
  return tree
}

export function pathFormatter(path, url) {
  const str = '\/sgm|\/setva|\/setvb|\/setvc|\/setvd|\/setve|\/setvf|\/setvg|\/setvh|\/detail|\/list|\/\\d+'
  return path.replace(new RegExp('(' + str + ')', 'g'), '')
}

export function submitForm(method, url, params, target) {
  var tempform = document.createElement('form')
  tempform.action = url
  tempform.method = method
  tempform.style.display = 'none'
  if (target) {
    tempform.target = target
  }

  for (var x in params) {
    const value = encodeURIComponent(params[x])
    if (value === '' || value === undefined) continue
    const opt = document.createElement('input')
    opt.name = x
    opt.value = params[x]
    tempform.appendChild(opt)
  }

  const opt2 = document.createElement('input')
  opt2.type = 'submit'
  tempform.appendChild(opt2)
  document.body.appendChild(tempform)
  tempform.submit()
  document.body.removeChild(tempform)
}
/**
 * 参数对象拼装为uri
 * @param {Object} params URL参数
 */
export function queryEncoded(params) {
  var queryStr = ''
  for (const key in params) {
    const value = encodeURIComponent(params[key])
    if (value === '' || value === undefined) continue
    queryStr += '&' + key + '=' + value
  }
  return queryStr.substr(1)
}
export function parseUrl(url) {
  var params = {}
  var urls = url.split('?')
  var paths = []
  var path = url = ''
  if (urls.length === 1) {
    urls[1] = url
  }
  paths = urls[0].split('#')
  if (paths.length === 1) {
    path = paths[0]
  } else if (paths.length === 2) {
    url = paths[0]
    path = paths[1]
  }
  var arr = urls[1].split('&')
  for (var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split('=')
    params[a[0]] = a[1]
  }
  return {
    url: url,
    path: path,
    query: params
  }
}
/**
 * 深度复制对象数组
 * @param {Object,Array} source 对象数组
 */
export function copyObject(source) {
  var sourceCopy = source instanceof Array ? [] : {}
  for (var item in source) {
    sourceCopy[item] = typeof source[item] === 'object' && source[item] !== null ? copyObject(source[item]) : source[item]
  }
  return sourceCopy
}
/**
 * 路由最后添加子车型
 * @param {String} route 路由
 * @param {String} subModelId 子车型
 */
export function addPath(route, subModelId) {
  const path = route.path
  const paths = path.split('/')
  if (isNaN(paths[paths.length - 1])) {
    paths.push(subModelId)
  } else {
    paths[paths.length - 1] = subModelId
  }
  return paths.join('/')
}

/**
 * 模拟点击a标签下载方法
 * @param {*} url 下载url
 */
export function invokeDownload(url) {
  const link = document.createElement('a')
  link.setAttribute('href', url)
  invokeClick(link)
}

/**
 * 兼容性click下载事件
 */
export function invokeClick(element) {
  if (element.fireEvent) {
    element.fireEvent('onclick')
  } else if (document.createEvent) {
    const event = document.createEvent('MouseEvents')
    event.initEvent('click', true, true)
    element.dispatchEvent(event)
  } else if (element.click) {
    element.click()
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper.js